module.exports = __webpack_public_path__ + "assets/img/28a4ec9d89b83821cd56dc9fd0d30578.png";